// Management Texts Suppression List
export const MANAGEMENT_MY_INTEGRATIONS = "si.management.my-integrations.title";
export const SL_MANAGEMENT_DISABLED_TOOLTIP = "si.management.sl.section.disabled.tooltip";

// Management Texts Salesforce List
export const MANAGEMENT_LAST_SYNCED_TEXT = "si.management.sf.section.info.list.synced.text";

//Exclusion
export const MANAGEMENT_SF_EXCLUSION_TITLE = "si.management.sf.section.info.accounts_exclusion.title";

//Export
export const MANAGEMENT_SF_EXPORT_TITLE = "si.management.sf.section.info.companies_export.title";
export const MANAGEMENT_EXPORT_TO_CRM_TITLE = "si.management.info.export_to_crm.title";
export const MANAGEMENT_EXPORT_TO_CRM_SHORT_TITLE = "si.common.export";

//Import
export const MANAGEMENT_IMPORT_FROM_CRM_TITLE = "si.management.info.import_from_crm.title";
export const MANAGEMENT_IMPORT_FROM_CRM_SHORT_TITLE = "si.common.import";

// Enrichment
export const MANAGEMENT_ENRICHMENT_TITLE = "si.management.enrichment.title";
export const MANAGEMENT_ENRICHMENT_PLAIN_TITLE = "si.management.enrichment.plain-title";

// Common
export const MANAGEMENT_COMMON_MANAGE = "si.common.manage";
export const MANAGEMENT_COMMON_CONNECT = "si.common.connect";
export const MANAGEMENT_COMMON_RECONNECT = "si.common.reconnect";
export const MANAGEMENT_CANCEL_TEXT = "si.common.button.cancel";
export const MANAGEMENT_COMMON_I_ACCEPT = "si.common.i.accept";
export const MANAGEMENT_COMMON_MINUTES = "si.common.minutes_ago";
export const MANAGEMENT_COMMON_HOURS = "si.common.hours_ago";
export const MANAGEMENT_COMMON_DAYS = "si.common.days_ago";
export const MANAGEMENT_COMMON_UPGRADE = "si.common.upgrade";

export const MANAGEMENT_EXCLUSION_INFO_ON = "si.management.sf.section.info.title.on";
export const MANAGEMENT_EXCLUSION_INFO_OFF = "si.management.sf.section.info.title.off";

export const MANAGEMENT_SF_INTEGRATION_NAME = "si.management.card.salesforce.title";
export const MANAGEMENT_HS_INTEGRATION_NAME = "si.management.card.hubspot.title";
export const MANAGEMENT_DYNAMICS_INTEGRATION_NAME = "si.management.card.dynamics.title";

export const MANAGEMENT_COMMON_DISABLED_TOOLTIP_LOADING = "si.management.disabled-tooltip.loading";

export const MANAGEMENT_SETTINGS_TITLE = "si.management.integrations.settings.title";
export const MANAGEMENT_BUTTON_MANAGE = "si.management.button.manage";

export const MANAGEMENT_CRMS_AND_CONNECTORS = "si.management.crms-and-connectors.header.title";
export const MANAGEMENT_CRMS_LABEL = "si.management.crms-and-connectors.crms.title";
export const MANAGEMENT_CONNECTORS_LABEL = "si.management.crms-and-connectors.connectors.title";
export const MANAGEMENT_APIS_AND_WEBHOOKS = "si.management.apis-and-webhooks.header.title";
export const MANAGEMENT_MCP_SERVERS = "si.management.mcp-servers.header.title";
